















import Vue from 'vue';
import Transcription from '@/store/modules/transcription';
import Dialog from '@/store/modules/dialog';
import Component from 'vue-class-component';
import store from '@/store/store';
import { getModule } from 'vuex-module-decorators';
import { IRect } from '@/types';
const trscModule = getModule(Transcription, store);

@Component({
  props: ['value'],
})
export default class AnnotationList extends Vue {
  annotations = trscModule.annotations;
}
